export type SubscriptionPlan = 'year' | 'month';

export const calculateSubscriptionCost = (activePlan: SubscriptionPlan) => {
  const monthlyPrice = 200;
  const isYearly = activePlan === 'year';

  if (isYearly) {
    const yearlyPrice = monthlyPrice * 12;
    const discount = 50;
    const discountedPrice = yearlyPrice * (1 - discount / 100);

    return {
      preliminaryTotal: yearlyPrice,
      discount: -discount,
      finalTotal: discountedPrice,
    };
  } else {
    return {
      preliminaryTotal: monthlyPrice,
      discount: 0,
      finalTotal: monthlyPrice,
    };
  }
};
